import React, { useState } from 'react';
import { Grid, User, LogOut, Settings } from 'lucide-react';
import { useAuth } from '../context/AuthContext.tsx';
import { useNavigate } from 'react-router-dom';

interface HeaderProps {
  toggleSidebar: () => void;
}

const Header = ({ toggleSidebar }: HeaderProps) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  const handleLogout = () => {
    setShowLogoutConfirm(true);
  };

  const confirmLogout = () => {
    logout();
    setShowLogoutConfirm(false);
  };

  const cancelLogout = () => {
    setShowLogoutConfirm(false);
  };

  const handleSettingsClick = () => {
    navigate('/ayarlar');
  };

  return (
    <header className="bg-gradient-to-r from-slate-800 via-gray-900 to-slate-800 shadow-lg border-b border-slate-700">
      <div className="flex items-center justify-between px-6 py-3.5">
        {/* Left side */}
        <div className="flex items-center space-x-4">
          <button
            onClick={toggleSidebar}
            className="lg:hidden p-2 rounded-xl hover:bg-white/10 text-white transition-all duration-200 hover:scale-105"
          >
            <Grid size={20} />
          </button>
        </div>

        {/* Right side */}
        <div className="flex items-center space-x-2">
          {/* Settings */}
          <button 
            onClick={handleSettingsClick}
            className="p-2.5 rounded-xl hover:bg-white/15 text-white transition-all duration-200 hover:scale-105 shadow-sm"
            title="Hesap Ayarları"
          >
            <Settings size={18} />
          </button>
          
          {/* User Profile */}
          <div className="flex items-center space-x-2 bg-white/15 backdrop-blur-md rounded-xl px-3 py-2 border border-white/20 shadow-sm">
            <div className="w-9 h-9 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-xl flex items-center justify-center text-white font-bold shadow-md">
              <User size={18} />
            </div>
            <div className="hidden md:block">
              <p className="text-sm font-bold text-white leading-tight">{user?.name || 'Admin'}</p>
              <p className="text-xs text-gray-300 font-medium leading-tight">{user?.email || 'admin@barkleyclub.com'}</p>
            </div>
            <button
              onClick={handleLogout}
              className="p-2 rounded-lg hover:bg-red-500/30 text-gray-200 hover:text-white transition-all duration-200 hover:scale-110"
              title="Çıkış Yap"
            >
              <LogOut size={16} />
            </button>
          </div>
        </div>
      </div>

      {/* Logout Confirmation Modal */}
      {showLogoutConfirm && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden">
            <div className="bg-gradient-to-r from-red-500 to-rose-600 px-6 py-4 flex items-center">
              <div className="w-12 h-12 bg-white/20 backdrop-blur rounded-xl flex items-center justify-center mr-4 shadow-lg">
                <LogOut className="w-6 h-6 text-white" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-white">Çıkış Yap</h3>
                <p className="text-sm text-red-100 font-medium">Hesabınızdan çıkış yapılıyor</p>
              </div>
            </div>
            
            <div className="p-6">
              <p className="text-gray-700 font-medium mb-6">Hesabınızdan çıkış yapmak istediğinizden emin misiniz?</p>
              
              <div className="flex space-x-3">
                <button
                  onClick={cancelLogout}
                  className="flex-1 px-5 py-3 text-gray-700 border-2 border-gray-300 rounded-xl hover:bg-gray-50 hover:border-gray-400 transition-all font-bold"
                >
                  İptal
                </button>
                <button
                  onClick={confirmLogout}
                  className="flex-1 px-5 py-3 bg-gradient-to-r from-red-600 to-rose-700 text-white rounded-xl hover:from-red-700 hover:to-rose-800 transition-all shadow-md hover:shadow-lg font-bold"
                >
                  Çıkış Yap
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;

